import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import { emptyObject } from "constants/defaultValues";
import * as V from "@totalsoft/pure-validations";
import { useValidation } from "@totalsoft/pure-validations-react";
import { Close } from "@material-ui/icons";

const ActionsDialog = (props) => {
  const { fullWidth, maxWidth, title, message, open, handleClose, actions, initialState, validator, Content } = props;
  const [dialogState, setDialogState] = useState(initialState || emptyObject);
  const [validation, validate] = useValidation(validator || V.shape({}));

  const handleAction = useCallback(
    (handle) => async () => {
      const handleOutput = handle && (await handle(dialogState, validate, validation));
      handleOutput && handleClose();
    },
    [handleClose, dialogState, validate, validation]
  );

  useEffect(() => {
    setDialogState(initialState || emptyObject);
  }, [open, initialState]);

  if (!open) return <></>;

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth={fullWidth || false}
      maxWidth={maxWidth ? "md" : "xs"}
    >
      <DialogTitle id="customized-dialog-title">
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h4">{title}</Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        {message && <Typography gutterBottom>{message}</Typography>}
        {Content && (
          <Content
            dialogState={dialogState}
            setDialogState={setDialogState}
            validate={validate}
            validation={validation}
          />
        )}
      </DialogContent>
      <DialogActions>
        {actions.map(({ handle, disabled, caption, color }, idx) => (
          <Button
            key={idx}
            disabled={disabled}
            onClick={handleAction(handle)}
            variant="contained"
            color={color ?? "primary"}
          >
            {caption}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};

ActionsDialog.propTypes = {
  fullWidth: PropTypes.bool,
  maxWidth: PropTypes.bool,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  actions: PropTypes.array.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  initialState: PropTypes.object,
  validator: PropTypes.object,
  Content: PropTypes.func,
};

export default ActionsDialog;
